import LegalLayout, { Section, SubTitle, List } from "./LegalLayout";

export default function Privacy() {
    return (
        <LegalLayout
            title="Privacy Policy"
            effectiveDate="13 February, 2026"
            intro="AV Consultation (&ldquo;we,&rdquo; &ldquo;our,&rdquo; or &ldquo;us&rdquo;) respects your privacy and is committed to protecting your personal information. This Privacy Policy explains how we collect, use, and safeguard your data when you visit our website or use our services."
        >
            <Section number={1} title="Information We Collect" testId="privacy-s1">
                <p>We may collect the following types of information:</p>

                <SubTitle>a) Personal Information</SubTitle>
                <List
                    items={[
                        "Name",
                        "Email address",
                        "Phone number",
                        "Business details (if provided)",
                    ]}
                />
                <p className="mt-4">This information is collected when you:</p>
                <List
                    items={[
                        "Fill out contact forms",
                        "Book a call",
                        "Communicate with us directly",
                    ]}
                />

                <SubTitle>b) Non-Personal Information</SubTitle>
                <List
                    items={[
                        "Browser type",
                        "Device information",
                        "IP address",
                        "Pages visited and time spent",
                    ]}
                />
                <p>This data helps us improve our website and services.</p>
            </Section>

            <Section number={2} title="How We Use Your Information" testId="privacy-s2">
                <p>We use your information to:</p>
                <List
                    items={[
                        "Respond to inquiries and communicate with you",
                        "Provide and improve our services",
                        "Send updates, proposals, or relevant information",
                        "Analyze website performance and user behavior",
                    ]}
                />
                <p>We do not sell your personal data to third parties.</p>
            </Section>

            <Section
                number={3}
                title="Cookies & Tracking Technologies"
                testId="privacy-s3"
            >
                <p>Our website may use cookies and similar technologies to:</p>
                <List
                    items={[
                        "Enhance user experience",
                        "Track website performance (e.g., analytics tools)",
                        "Support marketing and advertising efforts",
                    ]}
                />
                <p>You can choose to disable cookies through your browser settings.</p>
            </Section>

            <Section number={4} title="Third-Party Services" testId="privacy-s4">
                <p>
                    We may use third-party tools and platforms (such as
                    analytics, payment processors, or marketing tools). These
                    third parties may collect and process your data according
                    to their own privacy policies.
                </p>
                <p>
                    We are not responsible for how third-party services handle
                    your data.
                </p>
            </Section>

            <Section number={5} title="Data Protection" testId="privacy-s5">
                <p>
                    We take reasonable measures to protect your personal
                    information from:
                </p>
                <List
                    items={["Unauthorized access", "Misuse", "Disclosure"]}
                />
                <p>
                    However, no method of transmission over the internet is
                    100% secure.
                </p>
            </Section>

            <Section number={6} title="Data Retention" testId="privacy-s6">
                <p>We retain your information only as long as necessary to:</p>
                <List
                    items={[
                        "Provide services",
                        "Comply with legal obligations",
                        "Resolve disputes",
                    ]}
                />
            </Section>

            <Section number={7} title="Your Rights" testId="privacy-s7">
                <p>Depending on your location, you may have the right to:</p>
                <List
                    items={[
                        "Access the data we hold about you",
                        "Request correction or deletion",
                        "Withdraw consent for data usage",
                    ]}
                />
                <p>To exercise these rights, contact us at the email below.</p>
            </Section>

            <Section number={8} title="Children's Privacy" testId="privacy-s8">
                <p>
                    Our services are not intended for individuals under the age
                    of 18. We do not knowingly collect data from children.
                </p>
            </Section>

            <Section number={9} title="Changes to This Policy" testId="privacy-s9">
                <p>
                    We may update this Privacy Policy from time to time.
                    Updates will be posted on this page with a revised
                    effective date.
                </p>
            </Section>

            <Section number={10} title="Contact Us" testId="privacy-s10">
                <p>
                    If you have any questions about this Privacy Policy or
                    your data, you can contact:
                </p>
                <div className="mt-4 rounded-2xl border border-black/5 bg-[#FAFAFA] p-6">
                    <p className="font-display font-semibold text-[#0A0A0A]">
                        Ambuj Vats
                    </p>
                    <p className="text-gray-600">AV Consultation</p>
                    <p className="mt-2 text-gray-700">
                        Email:{" "}
                        <a
                            href="mailto:ambuj@av-consultation.com"
                            data-testid="privacy-contact-email"
                            className="font-semibold text-[#059669] hover:underline"
                        >
                            ambuj@av-consultation.com
                        </a>
                    </p>
                </div>
                <p className="mt-6 text-gray-600">
                    By using our website, you consent to this Privacy Policy.
                </p>
            </Section>
        </LegalLayout>
    );
}
